import {Callback} from "../core/Reflection";
import {SlotId} from "../data/StoryModel";
import {GameManager} from "../managers/GameManager";
import {Button} from "./Button";

export class SceneCreatorCarouselButton extends Button {

    constructor(slotId: SlotId, optionId: string, onClick: Callback) {
        super(onClick);

        // todo temp solution
        let textureName = "";
        switch (slotId) {
            case "character":
            case "characterOther":
                textureName = optionId + "-icon";
                break;
            case "outfit":
            case "outfitOther":
                const characterOption = GameManager.instance.getSelectedOption(
                    slotId === "outfit" ? "character" : "characterOther");
                if (characterOption) {
                    textureName = characterOption + "-" + optionId;
                }
                break;
            case "decorationLeft":
            case "decorationRight":
                textureName = "decoration-" + optionId;
                break;
            case "handItem":
                textureName = "item-" + optionId;
                break;
        }

        this.setLayoutTexture(textureName, 0.5, 1);
        this.scaleXY = 2;
    }
}
